import { render, staticRenderFns } from "./StockMateriaPrimeraMagatzemMateriaPrimeraList.vue?vue&type=template&id=62b0afd8&scoped=true"
import script from "./StockMateriaPrimeraMagatzemMateriaPrimeraList.vue?vue&type=script&lang=js"
export * from "./StockMateriaPrimeraMagatzemMateriaPrimeraList.vue?vue&type=script&lang=js"
import style0 from "./StockMateriaPrimeraMagatzemMateriaPrimeraList.vue?vue&type=style&index=0&id=62b0afd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b0afd8",
  null
  
)

export default component.exports